/**
 * Whether a string contains another string
 */
export default function containsWith(target, item) {
  // example 1: lenye_base.contains('Kevin', 'K')
  // returns 1: true
  return String(target).indexOf(item) !== -1;
}
